import React, { useState } from "react";

const SuccessStories = () => {
  const [active, setActive] = useState(1);

  const stories = [
    {
      id: 1,
      title: "Tyler’s Breakthrough",
      role: "Player",
      classYear: "Class of 2025",
      location: "Texas",
      img: "https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 2,
      title: "Sophia’s Rise",
      role: "Athlete",
      classYear: "Class of 2024",
      location: "California",
      img: "https://images.unsplash.com/photo-1550345332-09e3ac987658?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 3,
      title: "Ethan’s Journey",
      role: "Player",
      classYear: "Class of 2026",
      location: "Florida",
      img: "https://images.unsplash.com/photo-1521412644187-c49fa049e84d?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 4,
      title: "Ava’s Victory",
      role: "Athlete",
      classYear: "Class of 2023",
      location: "New York",
      img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 5,
      title: "Noah’s Transformation",
      role: "Player",
      classYear: "Class of 2025",
      location: "Ohio",
      img: "https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 6,
      title: "Liam’s Redemption",
      role: "Player",
      classYear: "Class of 2024",
      location: "Georgia",
      img: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 7,
      title: "Isabella’s Glory",
      role: "Athlete",
      classYear: "Class of 2023",
      location: "New York",
      img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 8,
      title: "James’s Rise",
      role: "Player",
      classYear: "Class of 2025",
      location: "Ohio",
      img: "https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 9,
      title: "Mason’s Comeback",
      role: "Player",
      classYear: "Class of 2024",
      location: "Georgia",
      img: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&q=80",
    },
  ];

  return (
    <section className="relative text-white bg-juco-gradient min-h-screen overflow-hidden w-full px-6 sm:px-10 md:px-16 lg:px-16 xl:px-16 pt-28 pb-12 md:pb-32">
      <h2 className="text-4xl md:text-5xl text-left font-normal leading-[125%] tracking-tight uppercase font-[Anton] mb-16 md:mb-24">
        Success Stories
      </h2>

      <div className="flex flex-wrap gap-4 w-full transition-all duration-500 justify-center">
        {stories.map((story) => {
          const isActive = active === story.id;
          return (
            <div
              key={story.id}
              onClick={() => setActive(story.id)}
              className={`relative rounded-md overflow-hidden cursor-pointer transition-all duration-700 ease-in-out
                    ${
                        isActive
                        ? "md:brightness-100 brightness-100 md:scale-105 md:w-[30%] lg:w-[30%] xl:w-[30%]"
                        : "md:brightness-75 brightness-90 md:w-[15.5%] lg:w-[15.5%] xl:w-[15.5%]"
                    } 
                    w-full sm:w-[48%]
                    h-[280px] sm:h-[340px] md:h-[380px] lg:h-[420px]`}
            >
              {/* Image */}
              <img
                src={story.img}
                alt={story.title}
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Overlay */}
              <div
                className={`absolute inset-0 flex flex-col justify-end p-6 transition-all duration-500 ${
                  isActive
                    ? "bg-black/0 backdrop-blur-0"
                    : "bg-black/40 backdrop-blur-[2px]"
                }`}
              >
                <p
                  className={`text-sm font-[Inter] ${
                    isActive ? "text-gray-200" : "text-gray-300"
                  }`}
                >
                  {story.role}
                </p>
                <h3 className="text-xl font-[Inter] font-semibold">{story.title}</h3>
                <div className="text-xs font-[Inter] text-gray-400 flex justify-between">
                  <span>{story.classYear}</span>
                  <span>{story.location}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SuccessStories;
